//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useEffect, useRef, useState } from "react";

import { useTheme } from '@mui/material/styles';
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  InputBase,
} from '@mui/material';

// === COMPONENTS ===

// === API ===
import { emit, updateAuditField } from "api/prokey/prokey.websocket";

//#endregion

//-----------------------------------------------------------------
export function Field({field, row, column}) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const theme         = useTheme();
  const ref_container = useRef();

  const content_original = field.Entries     ? field.Entries[0] .Content       : '';
  const header           = field.DisplayInfo ? field.DisplayInfo.DisplayHeader : '';
  const validation_color = field.passed ? theme.palette.success.main : theme.palette.error.main;
  const length           = field.DisplayInfo ? Math.max(field.DisplayInfo.Length * 12, 20 ) : '100%' ;

  //#endregion

  //#region [STYLES]

  const _styles = {
    container: {
      // gridColumn: column,
      // gridRow: row,
      height: '100%',
      marginTop: 'auto',
      backgroundColor: theme.palette.background.primary[theme.palette.mode],
    },
    header: {
      paddingTop    : '0rem',
      paddingBottom : '0rem',
      fontSize: '85%',
      whiteSpace: 'nowrap',
      backgroundColor: theme.palette.background.primary[theme.palette.mode],
    },
    content: {
      display: 'flex',
    },
    input: {
      borderStyle  : 'solid',
      borderWidth  : '2px',
      borderColor  : validation_color,
      borderRadius : '5px',
      paddingLeft  : '0.5rem',
      width        : length
    },
  }

  const
    CONTAINER = {
      sx  : _styles.container,
      ref : ref_container,
      variant: 'primary',
      onClick: () => { 
        emit( 'IMAGE', field.image );
        // Give image time to load
        setTimeout( () => emit( 'FILE_FIELD', { ...field, is_selected: true } ) , 250)
      },
    },
    HEADER = {
      sx    : _styles.header,
      title : field.document.NumCode ? field.document.NumCode + ' - ' + header : header,
    },
    CONTENT = {
      sx: _styles.content,
    },
    INPUT = {
      sx: _styles.input,
      disabled: field.isReadOnly,
      defaultValue: content_original,
      onKeyDown,
    };

  //#endregion

  //#region [EFFECT] 

  //#endregion

  //#region [EVENTS]

  //-----------------------------------------------------------------
  function onKeyDown(event) {
    //-----------------------------------------------------------------
    if (event.key === 'Enter' && event.ctrlKey) {
      // force accept
    } else if (event.key === 'Enter') {
      updateAuditField( field.id, {
        content : event.target.value      ,
        state   : field.Entries[0].State  ,
        left    : field.Entries[0].Left   ,
        top     : field.Entries[0].Top    ,
        right   : field.Entries[0].Right  ,
        bottom  : field.Entries[0].Bottom ,
      } )
    } else if (event.key === 'Tab' && !event.shiftKey) {
      event.preventDefault();

    }
  }

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function display() {
    //-----------------------------------------------------------------
    return (
      <Box { ...CONTAINER } >
        <CardHeader  { ...HEADER  }/>
        <CardContent { ...CONTENT } >
          <InputBase { ...INPUT } />
        </CardContent>
      </Box>
    )
  }

  //#endregion

  return display();
}